import { ModelBase } from 'store/model-base';

export class CmsBillingAdp extends ModelBase {
    public static storeName: string = 'cmsBillingAdp';

    public title: string;
    public checkIcon: CmsMediaImage;
    public paidDate: string;
}
